import { css } from 'styled-components'

export const treeItem = css`
  justify-content: flex-start;
  transition: padding 0.2s ease, line-height 0.2s ease;
  position: relative;
  display: flex;
  align-items: center;

  ${({ isActive, theme }) =>
    isActive &&
    css`
      color: ${theme.color.main};
    `}
  &:hover, &:focus {
    color: ${({ theme }) => theme.color.main};
  }

  .Button__label {
    transition: color 0.2s ease;
    white-space: nowrap;
  }

  .Icon {
    margin-right: 0.5rem;
    path {
      transition: color 0.2s ease;
    }
  }
`
